module.exports = __webpack_public_path__ + "img/HKLII_logo.d28f9f8a.svg";